<template>
  <div v-if="modalIsOpened" class="fixed inset-0 w-full bg-black/30 z-50">
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[450px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <div
            class="flex flex-col justify-center items-start gap-[22px] p-[20px]"
          >
            <div class="w-full flex flex-col items-center">
              <DownloadIcon class="w-[50px] h-[50px] p-[4px] text-primary" />
              <span class="PC_Body1-SB !text-[#1F1D1F] h-[24px]">
                ดาวน์โหลดรายงาน
              </span>
            </div>
            <SelectBoxComponent
              :inputId="'type'"
              :keyValue="'id'"
              :keyName="'name'"
              :options="Selector.downloadReportOption"
              :value="form.type"
              :label="'รูปแบบการดาวน์โหลด'"
              :placeholder="'เลือกรูปแบบ'"
              :lengthOptionList="3"
              @update:modelValue="
                (res) => {
                  form.type = res;
                  applyDefaultDateByType(Number(res));
                  // form.year = '';
                  // form.month = '';
                  // form.date = '';
                  // form.start_month = '';
                  // form.end_month = '';
                }
              "
            />
            <div v-if="form.type != ''" class="w-full flex flex-col gap-[8px]">
              <div v-if="form.type == 1" class="title">ระบุ ปี/เดือน/วัน</div>
              <div v-if="form.type == 2 || form.type == 3" class="title">
                ระบุ ปี/เดือน
              </div>
              <div v-if="form.type == 4" class="title">ระบุ ปี</div>
              <div
                class="w-full flex items-center gap-[8px] flex-wrap sm:flex-nowrap"
              >
                <SelectBoxComponent
                  selectContainerClass="!min-w-[0px]"
                  :inputId="'year'"
                  :keyValue="'id'"
                  :keyName="'name'"
                  :options="yearOptions"
                  :value="form.year"
                  :placeholder="'เลือกปี'"
                  :lengthOptionList="3"
                  @update:modelValue="
                    (res) => {
                      form.year = res;
                    }
                  "
                />
                <SelectBoxComponent
                  v-if="form.type == 1 || form.type == 2"
                  selectContainerClass="!min-w-[0px]"
                  :inputId="'month'"
                  :keyValue="'id'"
                  :keyName="'name'"
                  :options="Selector.monthOption"
                  :value="form.month"
                  :placeholder="'เลือกเดือน'"
                  :lengthOptionList="3"
                  @update:modelValue="
                    (res) => {
                      form.month = res;
                    }
                  "
                />
                <SelectBoxComponent
                  v-if="form.type == 1"
                  selectContainerClass="!min-w-[0px]"
                  :inputId="'day'"
                  :keyValue="'id'"
                  :keyName="'name'"
                  :options="Selector.dateOption"
                  :value="form.date"
                  :placeholder="'เลือกวันที่'"
                  :lengthOptionList="3"
                  @update:modelValue="
                    (res) => {
                      form.date = res;
                    }
                  "
                />
              </div>
              <div
                v-if="form.type == 3"
                class="w-full flex items-center justify-center gap-[8px] flex-wrap sm:flex-nowrap"
              >
                <SelectBoxComponent
                  selectContainerClass="!min-w-[0px]"
                  :inputId="'month01'"
                  :keyValue="'id'"
                  :keyName="'name'"
                  :options="Selector.monthOption"
                  :value="form.start_month"
                  :placeholder="'เลือกเดือน'"
                  :lengthOptionList="3"
                  @update:modelValue="
                    (res) => {
                      form.start_month = res;
                    }
                  "
                />
                <div class="labelL min-w-[17px]">ถึง</div>
                <SelectBoxComponent
                  selectContainerClass="!min-w-[0px]"
                  :inputId="'month02'"
                  :keyValue="'id'"
                  :keyName="'name'"
                  :options="Selector.monthOption"
                  :value="form.end_month"
                  :placeholder="'เลือกเดือน'"
                  :lengthOptionList="3"
                  @update:modelValue="
                    (res) => {
                      form.end_month = res;
                    }
                  "
                />
              </div>
            </div>
            <div class="w-full flex justify-center items-center gap-[10px]">
              <ButtonComponent
                :label="'ยกเลิก'"
                :bClass="'btn_shadow--cancel'"
                @clicked="closeModal"
              />
              <ButtonComponent
                v-if="report == 1"
                :label="'ดาวน์โหลด'"
                :bClass="'btn_shadow--save'"
                :disabled="form.type == '' || isDisabled"
                :href="downloadUrlForShelter"
              />
              <ButtonComponent
                v-if="report == 2"
                :label="'ดาวน์โหลด'"
                :bClass="'btn_shadow--save'"
                :disabled="form.type == '' || isDisabled"
                :href="downloadUrlForAssessments"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import {
  Selector,
  makeYearOptions,
} from "@/components/Utilities/javascripts/constants";

const yearOptions = computed(() => makeYearOptions());

const API_ORIGIN = computed(() => {
  const origin = window.location.origin;
  const isLocal =
    /^http:\/\/localhost(:\d+)?$/.test(origin) ||
    /^http:\/\/127\.0\.0\.1(:\d+)?$/.test(origin);
  return isLocal ? "https://dev.g-eoc.com" : origin;
});

const downloadUrlForShelter = computed(() => {
  const path = inShelter.value
    ? `/api/reports/shelter/${shelterId.value}`
    : "/api/reports/shelter";

  const base = new URL(path, API_ORIGIN.value).toString();
  const clean = Object.fromEntries(
    Object.entries(form.value).filter(
      ([, v]) => v !== "" && v !== null && v !== undefined
    )
  );

  const qs = new URLSearchParams(clean).toString();
  return qs ? `${base}?${qs}` : base;
});

const downloadUrlForAssessments = computed(() => {
  const path = `/api/reports/assessments/shelter/${shelterId.value}`;

  const base = new URL(path, API_ORIGIN.value).toString();
  const clean = Object.fromEntries(
    Object.entries(form.value).filter(
      ([, v]) => v !== "" && v !== null && v !== undefined
    )
  );

  const qs = new URLSearchParams(clean).toString();
  return qs ? `${base}?${qs}` : base;
});

const now = new Date();
const TODAY = {
  year: now.getFullYear(),
  month: now.getMonth() + 1,
  date: now.getDate(),
};

function applyDefaultDateByType(t) {
  // เคลียร์ก่อนทุกครั้ง
  form.value.year = "";
  form.value.month = "";
  form.value.date = "";
  form.value.start_month = "";
  form.value.end_month = "";

  if (t === 1) {
    // ปี/เดือน/วัน
    form.value.year = TODAY.year;
    form.value.month = TODAY.month;
    form.value.date = TODAY.date;
  } else if (t === 2) {
    // ปี/เดือน
    form.value.year = TODAY.year;
    form.value.month = TODAY.month;
  } else if (t === 3) {
    // ปี + ช่วงเดือน -> ตั้งเป็นเดือนปัจจุบันทั้งคู่
    form.value.year = TODAY.year;
    form.value.start_month = TODAY.month;
    form.value.end_month = TODAY.month;
  } else if (t === 4) {
    // ปี
    form.value.year = TODAY.year;
  }
}

const modalIsOpened = ref(false);
const input = {
  type: "",
  year: "",
  month: "",
  date: "",
  start_month: "",
  end_month: "",
};
const form = ref({ ...input });
const inShelter = ref(false);
const shelterId = ref("");
const report = ref("1");

const isEmpty = (v) =>
  v === "" ||
  v === null ||
  v === undefined ||
  (typeof v === "string" && v.trim() === "");

// disabled logic ตาม type
const isDisabled = computed(() => {
  const t = Number(form.value.type); // เผื่อ type เป็นสตริง แปลงเป็นตัวเลขให้ชัด
  const requiredMap = {
    1: ["year", "month", "date"],
    2: ["year", "month"],
    3: ["year", "start_month", "end_month"],
    4: ["year"],
  };

  const req = requiredMap[t] || [];

  // ทุกฟิลด์ที่ require ต้องไม่ว่าง
  const hasAll = req.every((k) => !isEmpty(form.value[k]));

  // กฎเพิ่มสำหรับ type 3: start_month <= end_month (ถ้ากรอกครบ)
  let rangeOK = true;
  if (t === 3 && hasAll) {
    const s = Number(form.value.start_month);
    const e = Number(form.value.end_month);
    rangeOK =
      !Number.isNaN(s) &&
      !Number.isNaN(e) &&
      s >= 1 &&
      s <= 12 &&
      e >= 1 &&
      e <= 12 &&
      s <= e;
  }

  return !(hasAll && rangeOK);
});

const openModal = (data, forReport) => {
  form.value = {
    ...input,
  };

  if (data) {
    inShelter.value = true;
    shelterId.value = data;
  } else {
    inShelter.value = false;
    shelterId.value = "";
  }
  if (forReport) {
    report.value = forReport;
  } else {
    report.value = "1";
  }
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

defineExpose({ openModal });
</script>

<style lang="scss" scoped>
.title {
  color: #1f1d1f;

  /* fields/title */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.1px;
}
.labelL {
  color: #1f1d1f;

  /* fields/label L */
  font-family: Kanit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
  letter-spacing: 0.1px;
}
</style>